import React from 'react';
import { Globe, Server, Smartphone, Database, Cloud, ShieldAlert } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Globe className="h-8 w-8 text-red-500" data-id="element-187" />,
    title: 'Web Application Testing',
    description: 'Comprehensive security assessment of web applications to identify vulnerabilities like XSS, CSRF, SQL injection and more.'
  }, {
    icon: <Server className="h-8 w-8 text-red-500" data-id="element-188" />,
    title: 'Network Penetration Testing',
    description: 'In-depth evaluation of network infrastructure to discover and exploit security weaknesses.'
  }, {
    icon: <Smartphone className="h-8 w-8 text-red-500" data-id="element-189" />,
    title: 'Mobile App Security Testing',
    description: 'Thorough analysis of mobile applications across iOS and Android platforms to uncover security flaws.'
  }, {
    icon: <Database className="h-8 w-8 text-red-500" data-id="element-190" />,
    title: 'API Security Assessment',
    description: 'Detailed examination of API endpoints to identify authentication issues, data exposure, and other vulnerabilities.'
  }, {
    icon: <Cloud className="h-8 w-8 text-red-500" data-id="element-191" />,
    title: 'Cloud Infrastructure Testing',
    description: 'Security evaluation of cloud environments including AWS, Azure, and Google Cloud configurations.'
  }, {
    icon: <ShieldAlert className="h-8 w-8 text-red-500" data-id="element-192" />,
    title: 'Social Engineering Testing',
    description: 'Simulated phishing campaigns and other social engineering tactics to test human-centric security vulnerabilities.'
  }];
  return <section id="services" className="py-20 bg-gray-900" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-196">
            Our Penetration Testing Services
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-gray-400 text-lg" data-id="element-197">
            Comprehensive security assessment services to identify
            vulnerabilities before malicious actors can exploit them.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-198">
          {services.map((service, index) => <div key={index} className="bg-gray-800 border border-gray-700 rounded-xl p-6 hover:border-red-500 transition-all duration-300 hover:shadow-lg hover:shadow-red-900/20" data-id="element-199">
              <div className="p-3 bg-red-900/20 rounded-lg inline-block mb-4" data-id="element-200">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-201">
                {service.title}
              </h3>
              <p className="text-gray-400" data-id="element-202">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}